"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TableCheckboxSelectAllHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TableCheckboxSelectAllHeader, _Component);

  var _super = _createSuper(TableCheckboxSelectAllHeader);

  function TableCheckboxSelectAllHeader(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, TableCheckboxSelectAllHeader);
    _this = _super.call(this, props);
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onCheckboxChanged = _this.onCheckboxChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      allChecked: false
    };
    return _this;
  }

  (0, _createClass2["default"])(TableCheckboxSelectAllHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkboxes = $('td.select input[name=select]').not(":disabled");
      this.checkboxes.change(this.onCheckboxChanged);
      this.onCheckboxChanged();
    }
  }, {
    key: "onCheckboxChanged",
    value: function onCheckboxChanged() {
      this.setState({
        allChecked: this.checkboxes.filter(':checked').length === this.checkboxes.length
      });
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      this.setState({
        allChecked: e.target.checked
      });
      this.checkboxes.prop('checked', e.target.checked);
      $(this.checkboxes[0]).trigger('change');
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "custom-control custom-checkbox d-inline-block",
        style: {
          marginBottom: "6px"
        }
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        name: "select_all_header",
        className: "custom-control-input",
        id: "id_select_all_header",
        onChange: this.onChange,
        checked: this.state.allChecked
      }), /*#__PURE__*/_react["default"].createElement("label", {
        className: "custom-control-label",
        htmlFor: "id_select_all_header"
      }, "Select All"));
    }
  }]);
  return TableCheckboxSelectAllHeader;
}(_react.Component);

exports["default"] = TableCheckboxSelectAllHeader;